import { PedidosModel } from "../../../../../../model/api/pedidos/pedidos-model";
import { CardPedidos } from "../../../../../components/cards/card-pedidos/card-pedidos";
export interface PedidosListDataProps {
  list: Array<PedidosModel>;
  lojaId: string
  carregando: boolean;
  selectedList: Array<string>;
  onCardChecked: (id: string) => any;
}

export const PedidosListData = (props: PedidosListDataProps) => {

  const onCardChecked = (id: string) => {
    props.onCardChecked(id);
  };

  return (
    <>
      {props.list.length > 0 &&
        props.list.map((pedidos, index) => {
          return (
            <CardPedidos
              index={index}
              selected={
                props.selectedList.filter((item) => item === pedidos.id).length >
                  0
                  ? true
                  : false
              }
              lojaId={props.lojaId}
              onCheck={onCardChecked}
              model={pedidos}
              key={pedidos.id}
            />
          );
        })}
    </>
  );
};
